import { Typography } from '@mui/material';
import { Grid2 } from "@mui/material";
import { ContentHubDamAsset, PageHeader } from '../../models/app-data-model';
import { getContentHubDamAsset } from "../../../shared/utils/get-contenthub-dam-asset";
import Button from '@mui/material/Button';
import React from 'react';
import './HeroComponent.scss';

export type HeroComponentProps = {
  hero: PageHeader;
  damAsset?: ContentHubDamAsset;
};

const HeroComponent: React.FC<HeroComponentProps> = ({ hero, damAsset }: HeroComponentProps) => {
  const prim_action_url = (hero.primary_action?.reference[0]?.url || getContentHubDamAsset(hero.primary_action?.reference[0]?.contenthub_asset)?.url);
  const sec_action_url = (hero.secondary_button?.reference[0]?.url || getContentHubDamAsset(hero.primary_action?.reference[0]?.contenthub_asset)?.url);

  return (
    <Grid2 container maxWidth="xl" className='hero' style={{backgroundImage:`url(${damAsset?.url})` }}>     
        <Grid2 size={{ md: 6}} className="content">
          <Typography variant='h1'>
            {hero.headline}
          </Typography>
          { hero.hero_copy && <Typography>
              {hero.hero_copy}
          </Typography> }
          <Grid2 container spacing={2}>
            { prim_action_url && hero.primary_action.label && <Button variant='contained' color='primary' size='large' title={hero.primary_action.label} href={prim_action_url}>
                {hero.primary_action.label}
            </Button> }
            { sec_action_url && hero.secondary_button.label && <Button variant='contained' color='inherit' size='large' title={hero.secondary_button.label} href={sec_action_url}>
                {hero.secondary_button.label}
            </Button> }
          </Grid2>
        </Grid2>
    </Grid2>
  );
};

export default HeroComponent;
